import React from 'react';
import { SectionType } from 'types/publishedAssets';
import { Spacer } from 'components/Atoms/Spacer/Spacer';
import { splitSectionEntitiesByColumn } from './helpers';
import { TitleText } from './Atoms/TitleText';
import styles from './SectionTwoColumn.module.scss';
import { Content } from './Content';

interface SectionTwoColumnProps {
  section: SectionType;
  isAfterHeroSection: boolean;
  title?: string;
  visuallyHideTitle?: boolean;
  headingId?: string;
}

export function SectionTwoColumn(props: SectionTwoColumnProps) {
  const { section, isAfterHeroSection, title, visuallyHideTitle, headingId } = props;
  const { leftColumn, rightColumn } = splitSectionEntitiesByColumn(section.section_entities);

  return (
    <div className={styles.outerContainer}>
      {title && (
        <>
          {/** skip hr if this section is after the hero section, or the title is only for a11y */}
          {!isAfterHeroSection && !visuallyHideTitle && <hr className={styles.sectionTitleSeparator} />}
          <TitleText text={title} id={headingId} type="sectionTitle" visuallyHidden={visuallyHideTitle} />
          <Spacer orientation="vertical" size="small" />
        </>
      )}
      <div className={styles.container}>
        <div className={styles.columnLeft}>
          {leftColumn.map((entity) => (
            <React.Fragment key={entity.id}>
              <Content key={entity.id} content={entity} section={section} />
              <Spacer orientation="vertical" size="medium" />
            </React.Fragment>
          ))}
        </div>
        <div className={styles.columnRight}>
          {rightColumn.map((entity) => (
            <React.Fragment key={entity.id}>
              <Content key={entity.id} content={entity} section={section} />
              <Spacer orientation="vertical" size="medium" />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
